import { getCompany, getConnector, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createLinkedAccountConnectedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.LINKED_ACCOUNT_CONNECTED,
        ...getUserAndEventTime(),
        data: {
            linkedAccount: {
                _id: '5f7212103a40e91f95ba376d',
                ...getConnector(),
                ...getCompany()
            }
        }
    };
};
//# sourceMappingURL=linked-account-connected.js.map